import(/* webpackMode: "eager" */ "/app/src/app/cv/page.tsx");
